export default {
  dir: 'ltr',
  welcome: 'Welcome',
  phone: 'Phone Number',
  login: 'LOGIN',
  editPhone: 'Edit Phone Number',
  verify:'verify',
  requiredPhone: "Please enter your mobile number",
  invalidPhone: "Invalid mobile number format"
 
}
